(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-header-section"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-2"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ncl-landing')) return;

    class NclLanding extends HTMLElement {
      connectedCallback() {
        if (this._ac) return;
        this._ac = new AbortController();
        var sig = { signal: this._ac.signal };
        this.modal = this.querySelector('.ncl-modal');
        this.toastEl = this.querySelector('.ncl-toast');
        var self = this;
        this.querySelectorAll('.ncl-carousel').forEach(function (c) { self.initCarousel(c, sig); });
        this.initMedia();
        this.initStories();
        this.initModal(sig);
        this.initForms();
        this.initBuy();
        this.initType();
        this.initEditor(sig);
        this.querySelectorAll('[data-ncl-scroll]').forEach(function (a) {
          a.addEventListener('click', function (e) {
            var t = document.getElementById(a.getAttribute('href').slice(1));
            if (!t) return;
            e.preventDefault();
            t.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      }

      disconnectedCallback() {
        if (this._ac) { this._ac.abort(); this._ac = null; }
        if (this._io) { this._io.disconnect(); this._io = null; }
        if (this._locked) { document.body.style.overflow = ''; this._locked = false; }
      }

      toast(msg) {
        var t = this.toastEl; if (!t || !msg) return;
        t.textContent = msg; t.classList.add('is-show');
        clearTimeout(this._tt); this._tt = setTimeout(function () { t.classList.remove('is-show'); }, 3200);
      }

      /* ---------- carousel (loops, swipeable) ---------- */
      initCarousel(root, sig) {
        var track = root.querySelector('.ncl-track');
        var vp = root.querySelector('.ncl-viewport');
        var slides = Array.prototype.slice.call(track.children);
        if (!slides.length) return;
        var dots = document.createElement('span');
        dots.className = 'ncl-dots';
        if (root.hasAttribute('data-nodots')) dots.hidden = true;
        root.appendChild(dots);
        var prev, next, i = 0;
        var per = function () { return parseFloat(getComputedStyle(root).getPropertyValue('--per')) || 1; };
        var maxI = function () { return Math.max(0, Math.ceil(slides.length - per())); };
        var chev = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
        if (root.hasAttribute('data-arrows')) {
          root.insertAdjacentHTML('beforeend', '<button type="button" class="ncl-arrow ncl-arrow--prev" aria-label="Previous">' + chev('m15 6-6 6 6 6') + '</button><button type="button" class="ncl-arrow ncl-arrow--next" aria-label="Next">' + chev('m9 6 6 6-6 6') + '</button>');
          prev = root.querySelector('.ncl-arrow--prev'); next = root.querySelector('.ncl-arrow--next');
          prev.addEventListener('click', function () { go(i - 1, true); });
          next.addEventListener('click', function () { go(i + 1, true); });
        }
        var lastN = -1;
        function buildDots() {
          var n = maxI() + 1, html = '';
          for (var k = 0; k < n; k++) html += '<button type="button" aria-label="Slide ' + (k + 1) + '"></button>';
          dots.innerHTML = html;
          dots.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
          dots.style.display = n > 1 ? '' : 'none';
        }
        function go(n, wrap) {
          var m = maxI();
          if (wrap) { if (n < 0) n = m; if (n > m) n = 0; }
          i = Math.max(0, Math.min(m, n));
          var w = slides[0].getBoundingClientRect().width;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.style.transform = 'translateX(' + (-i * (w + gap)) + 'px)';
          dots.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
          if (prev) { prev.hidden = next.hidden = m === 0; }
        }
        var sx = null, sy = null;
        vp.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; root.dataset.dragged = '0'; });
        vp.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 8) root.dataset.dragged = '1'; });
        vp.addEventListener('pointerup', function (e) {
          if (sx === null) return;
          var dx = e.clientX - sx, dy = e.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1), true);
          sx = null; setTimeout(function () { root.dataset.dragged = '0'; }, 50);
        });
        vp.addEventListener('pointerleave', function () { sx = null; });
        vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
        function refresh() { var n = maxI(); if (n !== lastN) { lastN = n; buildDots(); } go(i); }
        window.addEventListener('resize', refresh, sig);
        refresh();
        root._nclGoTo = function (el) {
          var k = -1;
          slides.forEach(function (sl, j) { if (sl === el || sl.contains(el)) k = j; });
          if (k > -1) go(Math.min(k, maxI()));
        };
      }

      /* ---------- media tiles ---------- */
      initMedia() {
        var self = this;
        this.querySelectorAll('.ncl-media.is-clickable').forEach(function (tile) {
          var open = function () {
            var car = tile.closest('.ncl-carousel');
            if (car && car.dataset.dragged === '1') return;
            var tpl = tile.querySelector('template.ncl-media__tpl');
            if (!tpl) return;
            self.openPanel('media', function (p) { p.innerHTML = ''; p.appendChild(tpl.content.cloneNode(true)); }, true);
          };
          tile.addEventListener('click', open);
          tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
        });
      }

      /* ---------- stories ---------- */
      initStories() {
        var wrap = this.querySelector('.ncl-stories'); if (!wrap) return;
        var self = this;
        var cards = Array.prototype.slice.call(wrap.querySelectorAll('.ncl-st'));
        var initial = parseInt(wrap.dataset.initial, 10) || 4;
        var btn = wrap.querySelector('[data-ncl-st-all]');
        var all = false;
        function render(anim) {
          cards.forEach(function (c, k) {
            var was = c.hidden; c.hidden = !all && k >= initial;
            c.classList.toggle('is-new', !!anim && was && !c.hidden);
          });
          if (btn) { btn.hidden = cards.length <= initial; btn.textContent = all ? wrap.dataset.less : wrap.dataset.all; }
        }
        this._stShowAll = function () { all = true; render(); };
        if (btn) btn.addEventListener('click', function () {
          all = !all; render(all);
          if (!all) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        var open = function (c) {
          self.openPanel('storyview', function (p) {
            p.innerHTML = '';
            var banner = c.querySelector('.ncl-st__banner').cloneNode(true);
            banner.classList.add('ncl-storyview__banner');
            p.appendChild(banner);
            var title = c.querySelector('.ncl-st__title'), date = c.querySelector('.ncl-st__date');
            if (title) { var h = document.createElement('span'); h.className = 'ncl-storyview__title'; h.textContent = title.textContent; p.appendChild(h); }
            if (date) { var d = document.createElement('span'); d.className = 'ncl-storyview__date'; d.textContent = date.textContent; p.appendChild(d); }
            var body = document.createElement('span'); body.className = 'ncl-storyview__body';
            body.appendChild(c.querySelector('template.ncl-st__tpl').content.cloneNode(true));
            p.appendChild(body);
          }, false);
        };
        cards.forEach(function (c) {
          c.addEventListener('click', function () { open(c); });
          c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(c); } });
        });
        render();
      }

      /* ---------- modal ---------- */
      initModal(sig) {
        var self = this, m = this.modal; if (!m) return;
        m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-ncl-close]')) self.closeModal(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('is-open')) self.closeModal(); }, sig);
        this.querySelectorAll('[data-ncl-open]').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); self.openPanel(b.dataset.nclOpen, null, false); });
        });
      }
      openPanel(name, fill, dark) {
        var m = this.modal; if (!m) return;
        var panel = null;
        m.querySelectorAll('.ncl-panel').forEach(function (p) {
          var on = p.dataset.panel === name; p.hidden = !on; if (on) panel = p;
        });
        if (!panel) return;
        if (fill) fill(panel);
        m.classList.toggle('is-media', !!dark);
        this._lastFocus = document.activeElement;
        m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
        if (!this._locked) { document.body.style.overflow = 'hidden'; this._locked = true; }
        setTimeout(function () {
          var f = panel.querySelector('input:not([type=hidden]),textarea,video,iframe,button') || m.querySelector('.ncl-modal__x');
          if (f) f.focus({ preventScroll: true });
        }, 60);
      }
      closeModal() {
        var m = this.modal; if (!m) return;
        m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
        if (this._locked) { document.body.style.overflow = ''; this._locked = false; }
        m.querySelectorAll('video').forEach(function (v) { v.pause(); });
        setTimeout(function () {
          if (m.classList.contains('is-open')) return;
          m.querySelectorAll('[data-panel="media"],[data-panel="storyview"]').forEach(function (p) { p.innerHTML = ''; });
        }, 260);
        if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus({ preventScroll: true });
      }

      /* ---------- story form ---------- */
      initForms() {
        var self = this;
        // After a form posts, Shopify reloads the page with the form's id in the hash.
        var hash = location.hash.slice(1);
        if (!hash) return;
        this.querySelectorAll('.ncl-modal form').forEach(function (f) {
          if (f.id !== hash) return;
          var errBox = f.querySelector('[data-ncl-err]'), ok = f.querySelector('[data-ncl-ok]');
          if (errBox) self.openPanel(f.closest('.ncl-panel').dataset.panel, null, false);
          else if (ok) self.toast(ok.textContent);
        });
      }

      /* ---------- add to cart ---------- */
      initBuy() {
        var self = this;
        var addUrl = (this.dataset.cartAdd || '/cart/add') + '.js';
        this.querySelectorAll('form.ncl-buy').forEach(function (f) {
          f.addEventListener('submit', function (e) {
            if (!window.fetch || !window.FormData) return;
            e.preventDefault();
            var btn = f.querySelector('button[type=submit]');
            if (!btn || btn.disabled) return;
            btn.disabled = true; btn.classList.add('is-loading');
            var data = new FormData(f);
            data.delete('return_to');
            fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data })
              .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
              .then(function (res) {
                if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || '');
                var after = self.dataset.after;
                if (after === 'checkout') { window.location.href = '/checkout'; return; }
                if (after === 'cart') { window.location.href = self.dataset.cart || '/cart'; return; }
                self.toast(self.dataset.added);
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                btn.disabled = false; btn.classList.remove('is-loading');
              })
              .catch(function (err) {
                self.toast((err && err.message) || self.dataset.cartError);
                btn.disabled = false; btn.classList.remove('is-loading');
              });
          });
        });
      }

      /* ---------- typing headline ---------- */
      initType() {
        var el = this.querySelector('[data-ncl-type]'); if (!el) return;
        var full = el.dataset.nclType;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var design = window.Shopify && window.Shopify.designMode;
        if (reduced || design || !('IntersectionObserver' in window)) {
          el.textContent = full; el.insertAdjacentHTML('beforeend', '<span class="ncl-caret" aria-hidden="true"></span>'); return;
        }
        el.setAttribute('aria-label', full);
        el.innerHTML = '<span class="ncl-tw" aria-hidden="true"></span><span class="ncl-caret" aria-hidden="true"></span>';
        var out = el.querySelector('.ncl-tw');
        var self = this;
        this._io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          self._io.disconnect(); self._io = null;
          var n = 0;
          var tick = function () { out.textContent = full.slice(0, ++n); if (n < full.length) setTimeout(tick, 55); };
          tick();
        }, { threshold: 0.6 });
        this._io.observe(el);
      }

      /* ---------- theme editor ---------- */
      initEditor(sig) {
        var self = this;
        document.addEventListener('shopify:block:select', function (e) {
          if (!e.detail || e.detail.sectionId !== self.dataset.section) return;
          var el = self.querySelector('[data-block-id="' + e.detail.blockId + '"]');
          if (!el) return;
          var car = el.closest('.ncl-carousel');
          if (car && car._nclGoTo) car._nclGoTo(el);
          if (el.classList.contains('ncl-st') && el.hidden && self._stShowAll) self._stShowAll();
        }, sig);
      }
    }

    customElements.define('ncl-landing', NclLanding);
  })();

  } catch(e) { console.error(e); }
})();
})();
